import * as React from 'react';
import { Component } from 'react';
import { getFormComponent } from './utils';

class TwoColumnFormSection extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const leftColumnCompmonents = (<div className="form-fields">
            {
                this.props.section.zones[0].formComponents.map((formComponent, key) => {
                    return getFormComponent(formComponent, this.props);
                })
            }
        </div>);
        const rightColumnCompmonents = (<div className="form-fields">
            {
                this.props.section.zones[1].formComponents.map((formComponent, key) => {
                    return getFormComponent(formComponent, this.props);
                })
            }
        </div>);
        return (
            <div style={this.props.visible && !this.props.posted ? {} : { display: 'none' }} className={this.props.isHighlighted ? "form-section highlighted" : "form-section"}>
                <div className="row">
                    <div className={this.props.type === "5050" ? "col-md-6" : this.props.type === "3366" ? "col-md-4" : "col-md-6"}>{leftColumnCompmonents}</div>
                    <div className={this.props.type === "5050" ? "col-md-6" : this.props.type === "3366" ? "col-md-8" : "col-md-6"}>{rightColumnCompmonents}</div>
                </div>
            </div>
        )
    }
}

export default TwoColumnFormSection;